function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import moment from 'moment';
import { USER_PREFERRED_GROUP_ADDED, USER_PREFERRED_GROUP_REMOVED } from 'researcher/user/constants';
// eslint-disable-next-line import/no-cycle
import { searchPlagiarism } from 'researcher/plagiarism/actions';
import { recordFreeTrialPurchaseInitiated, recordPurchaseComplete } from 'researcher/helpers/gtm';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import * as c from './constants';
import { getNextStep, getUpdatedResponses, getCurrencyIsoCode } from './reducer';
import { paddleEventCallback } from './helpers/paddleCallbacks';
export var loadUser = function loadUser() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState, _ref) {
      var application, curieLoadResult, paddleStatus, ithenticateStatus, paddlePriceLoad, transactionPreview;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            application = _ref.application;
            dispatch({
              type: c.RUBRIQ_LOAD_REQUESTED
            });
            _context.next = 4;
            return dispatch(application.get("/api/curie/load"));
          case 4:
            curieLoadResult = _context.sent;
            _context.next = 7;
            return dispatch(application.get("/api/curie/status/sync"));
          case 7:
            paddleStatus = _context.sent;
            dispatch(_objectSpread(_objectSpread({
              type: c.CURIE_DATA_UPDATED
            }, curieLoadResult), paddleStatus));
            _context.next = 11;
            return dispatch(application.get("/api/curie/ithenticate/status/sync"));
          case 11:
            ithenticateStatus = _context.sent;
            dispatch(_objectSpread({
              type: c.PLAGIARISM_PLAN_UPDATE_SYNCED
            }, ithenticateStatus));
            _context.next = 15;
            return dispatch(fetchPaddlePrices());
          case 15:
            paddlePriceLoad = _context.sent;
            _context.next = 18;
            return dispatch(fetchTransactionPreview());
          case 18:
            transactionPreview = _context.sent;
            dispatch(_objectSpread(_objectSpread(_objectSpread({
              type: c.RUBRIQ_LOAD_COMPLETED
            }, curieLoadResult), paddleStatus), {}, {
              transactionPreview: transactionPreview
            }));
            return _context.abrupt("return", _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, curieLoadResult), paddleStatus), ithenticateStatus), paddlePriceLoad), {}, {
              transactionPreview: transactionPreview
            }));
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var syncUser = function syncUser() {
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    return dispatch(application.get("/api/curie/load")).then(function (json) {
      dispatch(_objectSpread({
        type: c.RUBRIQ_SYNCED
      }, json));
    });
  };
};
var POLLING_INTERVAL = 3000;
var MAX_POLLING_ATTEMPTS = 20;
var isPolling = false;
var hasAnyPendingPayments = function hasAnyPendingPayments(state) {
  var _state$curie;
  var docStatuses = ((_state$curie = state.curie) === null || _state$curie === void 0 || (_state$curie = _state$curie.plagiarismStatus) === null || _state$curie === void 0 ? void 0 : _state$curie.documentStatuses) || {};
  return Object.values(docStatuses).some(function (doc) {
    return doc.paddlePending === true;
  });
};
export var syncPlagiarism = function syncPlagiarism() {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState, _ref4) {
      var application, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            application = _ref4.application;
            _context2.next = 3;
            return dispatch(application.get('/api/curie/ithenticate/status/sync'));
          case 3:
            response = _context2.sent;
            dispatch({
              type: c.PLAGIARISM_PLAN_UPDATE_SYNCED,
              status: response.status
            });
            return _context2.abrupt("return", response);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x4, _x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var _pollPlagiarismStatus = function pollPlagiarismStatus() {
  var retryCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var state;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!isPolling) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            isPolling = true;
            if (!(retryCount >= MAX_POLLING_ATTEMPTS)) {
              _context3.next = 7;
              break;
            }
            dispatch(notifyAboutDoccumentIthenticateStatusUpdate('payment_timeout', false));
            isPolling = false;
            return _context3.abrupt("return");
          case 7:
            _context3.prev = 7;
            _context3.next = 10;
            return dispatch(syncPlagiarism());
          case 10:
            state = getState();
            if (hasAnyPendingPayments(state)) {
              setTimeout(function () {
                isPolling = false;
                dispatch(_pollPlagiarismStatus(retryCount + 1));
              }, POLLING_INTERVAL);
            } else {
              dispatch(searchPlagiarism());
              dispatch(notifyAboutDoccumentIthenticateStatusUpdate('purchase_successful', true));
              isPolling = false;
            }
            _context3.next = 17;
            break;
          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](7);
            setTimeout(function () {
              isPolling = false;
              dispatch(_pollPlagiarismStatus(retryCount + 1));
            }, POLLING_INTERVAL);
          case 17:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[7, 14]]);
    }));
    return function (_x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export { _pollPlagiarismStatus as pollPlagiarismStatus };
export var syncPlagiarismPaymentStatus = function syncPlagiarismPaymentStatus(fileIdentity) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState, _ref7) {
      var application, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            application = _ref7.application;
            _context4.next = 3;
            return dispatch(application.post('/api/curie/ithenticate/status/sync', {
              fileIdentity: fileIdentity
            }));
          case 3:
            response = _context4.sent;
            dispatch({
              type: c.PLAGIARISM_PAYMENT_SYNCED,
              status: response.status
            });
            return _context4.abrupt("return", response);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x9, _x10, _x11) {
      return _ref8.apply(this, arguments);
    };
  }();
};
export var eulaTermsAndConditionsload = function eulaTermsAndConditionsload(lang) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState, _ref9) {
      var application, response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            application = _ref9.application;
            _context5.next = 3;
            return application.post("/api/ithenticate/ithenticate-eula/".concat(lang))();
          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x12, _x13, _x14) {
      return _ref10.apply(this, arguments);
    };
  }();
};
export var eulaStatusCheck = function eulaStatusCheck(lang, fileIdentity) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState, _ref11) {
      var application, response;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            application = _ref11.application;
            _context6.next = 3;
            return application.post("/api/ithenticate/ithenticate-eula-accept/".concat(lang, "/").concat(fileIdentity))();
          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x15, _x16, _x17) {
      return _ref12.apply(this, arguments);
    };
  }();
};
export var archivePlagiarismDocument = function archivePlagiarismDocument(id, fileName) {
  var removeOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState, _ref13) {
      var application;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            application = _ref13.application;
            return _context7.abrupt("return", dispatch(application.post("/api/ithenticate/".concat(id, "/archive"))).then(function (json) {
              if (!(json !== null && json !== void 0 && json.success)) {
                dispatch(application.addMessage({
                  type: 'error',
                  message: 'plagiarism-delete-failed'
                }));
                return json;
              }
              if (removeOnSuccess) {
                dispatch(removePlagiarismDocument(id));
              }
              dispatch(application.addMessage({
                type: 'success',
                message: '%(fileName)s deleted',
                params: {
                  fileName: fileName
                }
              }));
              return json;
            }));
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x18, _x19, _x20) {
      return _ref14.apply(this, arguments);
    };
  }();
};
export var removePlagiarismDocument = function removePlagiarismDocument(id) {
  return {
    type: 'PLAGIARISM_DOCUMENT_ARCHIVED',
    id: id
  };
};
export var loadDigitalEditLimitReached = function loadDigitalEditLimitReached() {
  return function (dispatch, getState, _ref15) {
    var application = _ref15.application;
    return dispatch(application.get('/api/digital-edit/limit-reached')).then(function (json) {
      dispatch(_objectSpread({
        type: c.DIGITAL_EDIT_LIMIT_REACHED_LOADED
      }, json));
    });
  };
};
export var loadDigitalAbstractLimitReached = function loadDigitalAbstractLimitReached() {
  return function (dispatch, getState, _ref16) {
    var application = _ref16.application;
    return dispatch(application.get('/api/digital-abstract/limit-reached')).then(function (json) {
      dispatch(_objectSpread({
        type: c.DIGITAL_ABSTRACT_LIMIT_REACHED_LOADED
      }, json));
    });
  };
};
export var addPreferredGroup = function addPreferredGroup(_, groupCode) {
  return function (dispatch, getState, _ref17) {
    var application = _ref17.application;
    if (getState().curie.plan.planType === 'free_trial') {
      return dispatch(setError({
        title: 'curie.incompatible-plans-title',
        content: 'curie.incompatible-plans-message',
        primaryBtnText: 'got-it'
      }));
    }
    return dispatch(application.post("/api/users/".concat(getState().user.identity, "/preferred-group"), {
      groupCode: groupCode
    })).then(function (json) {
      if (json.error) {
        dispatch(setError(c.RUBRIQ_DIGITAL_EDITING_ERRORS.PREFERRED_GROUP_GENERIC_ERROR));
      } else {
        dispatch(application.addMessage({
          type: 'success',
          message: 'You have been associated with the group code you entered.'
        }));
      }
      if (json.preferredGroup) {
        dispatch({
          type: USER_PREFERRED_GROUP_ADDED,
          preferredGroup: json.preferredGroup
        });
      }
      setTimeout(function () {
        dispatch(loadUser());
      }, 2000);
      return json;
    });
  };
};
export var removePreferredGroup = function removePreferredGroup() {
  return function (dispatch, getState, _ref18) {
    var application = _ref18.application;
    var groupCode = getState().user.preferredGroup.code;
    return dispatch(application.del("/api/users/".concat(getState().user.identity, "/preferred-group"))).then(function (json) {
      if (json.error) {
        dispatch(setError(c.RUBRIQ_DIGITAL_EDITING_ERRORS.PREFERRED_GROUP_GENERIC_ERROR));
      } else {
        dispatch(application.addMessage({
          type: 'success',
          message: 'preferred-group-leave-success',
          params: {
            groupCode: groupCode
          }
        }));
      }
      if (!json.preferredGroup) {
        dispatch({
          type: USER_PREFERRED_GROUP_REMOVED
        });
        // TODO: Put this somewhere better after launch
        // Only clear out the plan if it was an entitlement from the group they just left
        if (getState().curie.plan.planType === 'preferred_group') {
          dispatch({
            type: c.CLEAR_RUBRIQ_PLAN
          });
        }
      }
      setTimeout(function () {
        dispatch(loadUser());
      }, 2000);
      return json;
    });
  };
};
export var setError = function setError(error) {
  return function (dispatch) {
    return dispatch({
      type: c.ERROR_UPDATED,
      error: error
    });
  };
};
export var resetError = function resetError() {
  return function (dispatch) {
    return dispatch({
      type: c.ERROR_UPDATED,
      error: null
    });
  };
};
export var flagPlanUpdate = function flagPlanUpdate() {
  return /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch, getState, _ref19) {
      var application, json;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            application = _ref19.application;
            _context8.next = 3;
            return dispatch(application.post("/api/curie/status/sync"));
          case 3:
            json = _context8.sent;
            dispatch(_objectSpread({
              type: c.PLAN_UPDATE_FLAGGED
            }, json));
            return _context8.abrupt("return", json);
          case 6:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x21, _x22, _x23) {
      return _ref20.apply(this, arguments);
    };
  }();
};
export var syncPlanUpdate = function syncPlanUpdate() {
  return function (dispatch, getState, _ref21) {
    var application = _ref21.application;
    return dispatch(application.get("/api/curie/status/sync")).then(function (json) {
      dispatch(_objectSpread({
        type: c.PLAN_UPDATE_SYNCED
      }, json));
    });
  };
};
export var fetchPlanManagementUrls = function fetchPlanManagementUrls() {
  return function (dispatch, getState, _ref22) {
    var application = _ref22.application;
    return dispatch(application.get('/api/curie/plan-management-urls/get')).then(function (json) {
      return json;
    });
  };
};

/** The cardless trial is always a Rubriq Premium (editing only) trial. */
var CARDLESS_TRIAL_PRODUCT_NAME = 'Rubriq Premium';

/**
 * Starts a cardless trial by asking the backend to create a Paddle transaction
 * via POST /transactions (status: billed). No checkout overlay is shown — the
 * subscription is created server-side and provisioned via the subscription.created webhook.
 *
 * The trial-start conversion is reported here rather than in the components so every
 * entry point (pricing page, navbar) reports it exactly once. Under
 * rubriq_cardless_free_trial this is the only place a trial can start, because the plan
 * cards sell no-trial SKUs and so no longer fire free_trial_purchase_initiated themselves.
 */
export var startCardlessTrial = function startCardlessTrial(_ref23) {
  var priceId = _ref23.priceId,
    billingInterval = _ref23.billingInterval,
    _ref23$source = _ref23.source,
    source = _ref23$source === void 0 ? 'pricing_page' : _ref23$source;
  return /*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(dispatch, getState, _ref24) {
      var application, response;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            application = _ref24.application;
            _context9.prev = 1;
            _context9.next = 4;
            return dispatch(application.post('/api/curie/cardless-trial/start', {
              priceId: priceId,
              billingInterval: billingInterval
            }));
          case 4:
            response = _context9.sent;
            if (response !== null && response !== void 0 && response.success) {
              dispatch(application.addMessage({
                type: 'success',
                message: 'rubriq.cardless-trial-started'
              }));
              recordFreeTrialPurchaseInitiated({
                buttonText: 'start_cardless_free_trial_btn',
                productName: CARDLESS_TRIAL_PRODUCT_NAME,
                finalAmount: 0,
                currency: getCurrencyIsoCode(getState())
              });
              trackRubriqEvent('Trial Started', {
                planName: CARDLESS_TRIAL_PRODUCT_NAME,
                billing_cycle: billingInterval,
                trial_type: 'cardless',
                source: source
              });

              // The subscription is provisioned by the subscription.created webhook, so
              // the reload is delayed to give it a chance to land first.
              setTimeout(function () {
                dispatch(loadUser());
              }, 3000);
            } else {
              dispatch(application.addMessage({
                type: 'error',
                message: (response === null || response === void 0 ? void 0 : response.error) || 'rubriq.cardless-trial-start-failed'
              }));
            }
            return _context9.abrupt("return", response);
          case 9:
            _context9.prev = 9;
            _context9.t0 = _context9["catch"](1);
            dispatch(application.addMessage({
              type: 'error',
              message: 'rubriq.cardless-trial-start-failed'
            }));
            return _context9.abrupt("return", {
              success: false
            });
          case 13:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[1, 9]]);
    }));
    return function (_x24, _x25, _x26) {
      return _ref25.apply(this, arguments);
    };
  }();
};
export var updateCardlessTrialPlanItems = function updateCardlessTrialPlanItems(_ref26) {
  var priceId = _ref26.priceId;
  return /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(dispatch, getState, _ref27) {
      var application, response;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            application = _ref27.application;
            _context10.next = 3;
            return dispatch(application.post('/api/curie/cardless-trial/upgrade/items', {
              priceId: priceId
            }));
          case 3:
            response = _context10.sent;
            if (response !== null && response !== void 0 && response.success) {
              _context10.next = 6;
              break;
            }
            throw new Error((response === null || response === void 0 ? void 0 : response.error) || 'update-items-failed');
          case 6:
            return _context10.abrupt("return", response);
          case 7:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function (_x27, _x28, _x29) {
      return _ref28.apply(this, arguments);
    };
  }();
};

/**
 * Charges and activates the subscription the cardless trial was switched to, which is the
 * moment a trial becomes a paying subscription.
 *
 * The arguments describe what the user ended up buying, so the conversion can be reported
 * with the right revenue and plan — including when they upgraded to Translation, which no
 * other purchase event covers. `subscriptionId` from the backend is unique per
 * subscription and a trial is upgraded at most once, so a retry cannot double-count.
 *
 * @param {object} [plan]        The no-trial plan now on the subscription
 * @param {number} [amount]      Charged amount, in the currency shown to the user
 * @param {string} [productName] Plan name as reported to analytics
 */
export var activateCardlessTrialUpgrade = function activateCardlessTrialUpgrade() {
  var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    plan = _ref29.plan,
    amount = _ref29.amount,
    productName = _ref29.productName;
  return /*#__PURE__*/function () {
    var _ref31 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(dispatch, getState, _ref30) {
      var application, response, _response$subscriptio, transactionId;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            application = _ref30.application;
            _context11.next = 3;
            return dispatch(application.post('/api/curie/cardless-trial/upgrade/activate', {}));
          case 3:
            response = _context11.sent;
            if (response !== null && response !== void 0 && response.success) {
              _context11.next = 6;
              break;
            }
            throw new Error((response === null || response === void 0 ? void 0 : response.error) || 'activate-failed');
          case 6:
            if (plan) {
              transactionId = "cardless_upgrade_".concat((_response$subscriptio = response.subscriptionId) !== null && _response$subscriptio !== void 0 ? _response$subscriptio : plan.paddlePlanId);
              recordPurchaseComplete({
                transactionId: transactionId,
                orderId: transactionId,
                revenue: amount !== null && amount !== void 0 ? amount : plan.price,
                currency: getCurrencyIsoCode(getState()),
                productName: productName,
                planTerm: plan.billingInterval === c.PADDLE_PLAN_TYPES.YEARLY ? 'Yearly' : 'Monthly',
                paymentMode: 'paddle'
              });
              trackRubriqEvent('Trial Upgraded To Paid', {
                planName: productName,
                billing_cycle: plan.billingInterval,
                price: amount !== null && amount !== void 0 ? amount : plan.price,
                trial_type: 'cardless'
              });
            }
            dispatch(loadUser());
            return _context11.abrupt("return", response);
          case 9:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function (_x30, _x31, _x32) {
      return _ref31.apply(this, arguments);
    };
  }();
};
export var fetchCardlessPaymentMethodTransaction = function fetchCardlessPaymentMethodTransaction() {
  return /*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(dispatch, getState, _ref32) {
      var application, response;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            application = _ref32.application;
            _context12.next = 3;
            return dispatch(application.get('/api/curie/paddle/payment-method-transaction'));
          case 3:
            response = _context12.sent;
            if (response !== null && response !== void 0 && response.transactionId) {
              _context12.next = 6;
              break;
            }
            throw new Error((response === null || response === void 0 ? void 0 : response.error) || 'no-transaction-id');
          case 6:
            return _context12.abrupt("return", response.transactionId);
          case 7:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function (_x33, _x34, _x35) {
      return _ref33.apply(this, arguments);
    };
  }();
};
export var startSubscriptionImmediately = function startSubscriptionImmediately(subscriptionId) {
  return /*#__PURE__*/function () {
    var _ref35 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(dispatch, getState, _ref34) {
      var application, response, reason, showChangeBillingLink;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            application = _ref34.application;
            _context14.next = 3;
            return dispatch(application.post('/api/curie/plan-start-immediately/post', {
              subscriptionId: subscriptionId
            }));
          case 3:
            response = _context14.sent;
            if (response !== null && response !== void 0 && response.success) {
              dispatch({
                type: c.START_SUBSCRIPTION_TODAY
              });
              dispatch(application.addMessage({
                type: 'success',
                message: 'rubriq.subscription-started-successfully'
              }));
              setTimeout(function () {
                dispatch(loadUser());
              }, 2000);
            } else {
              reason = response === null || response === void 0 ? void 0 : response.reason;
              showChangeBillingLink = reason === 'consent-required' || reason === 'payment-declined';
              dispatch(application.addMessage({
                type: 'error',
                message: showChangeBillingLink ? reason : 'rubriq.subscription-start-failed',
                customRender: showChangeBillingLink ? 'subscriptionErrorWithLink' : null,
                onLinkClick: showChangeBillingLink ? /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
                  var data;
                  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                    while (1) switch (_context13.prev = _context13.next) {
                      case 0:
                        _context13.next = 2;
                        return dispatch(fetchPlanManagementUrls());
                      case 2:
                        data = _context13.sent;
                        if (data !== null && data !== void 0 && data.updateUrl) {
                          window.open(data.updateUrl, '_blank');
                        }
                      case 4:
                      case "end":
                        return _context13.stop();
                    }
                  }, _callee13);
                })) : undefined
              }));
            }
            return _context14.abrupt("return", response);
          case 6:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    return function (_x36, _x37, _x38) {
      return _ref35.apply(this, arguments);
    };
  }();
};
export var createUserActivity = function createUserActivity(_ref37) {
  var feature = _ref37.feature,
    submissionIdentity = _ref37.submissionIdentity,
    activity = _ref37.activity;
  return /*#__PURE__*/function () {
    var _ref39 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(dispatch, getState, _ref38) {
      var application;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            application = _ref38.application;
            return _context15.abrupt("return", dispatch(application.post('/api/digital-edit/survey', {
              feature: feature,
              submissionIdentity: submissionIdentity,
              activity: activity
            })));
          case 2:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return function (_x39, _x40, _x41) {
      return _ref39.apply(this, arguments);
    };
  }();
};
export var cancelSubscriptionImmediately = function cancelSubscriptionImmediately(subscriptionId) {
  return /*#__PURE__*/function () {
    var _ref41 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(dispatch, getState, _ref40) {
      var _window$Paddle;
      var application, retainAvailable, _result, _result2, _result4, result, _result3, response;
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            application = _ref40.application;
            retainAvailable = typeof window !== 'undefined' && ((_window$Paddle = window.Paddle) === null || _window$Paddle === void 0 || (_window$Paddle = _window$Paddle.Retain) === null || _window$Paddle === void 0 ? void 0 : _window$Paddle.initCancellationFlow) && typeof window.profitwell === 'function';
            if (!retainAvailable) {
              _context16.next = 18;
              break;
            }
            _context16.prev = 3;
            _context16.next = 6;
            return window.Paddle.Retain.initCancellationFlow({
              subscriptionId: subscriptionId
            });
          case 6:
            result = _context16.sent;
            _context16.next = 12;
            break;
          case 9:
            _context16.prev = 9;
            _context16.t0 = _context16["catch"](3);
            result = {
              status: 'error'
            };
          case 12:
            if (!(((_result = result) === null || _result === void 0 ? void 0 : _result.status) === 'retained' || ((_result2 = result) === null || _result2 === void 0 ? void 0 : _result2.status) === 'aborted')) {
              _context16.next = 14;
              break;
            }
            return _context16.abrupt("return", {
              success: true,
              retained: true,
              status: (_result3 = result) === null || _result3 === void 0 ? void 0 : _result3.status
            });
          case 14:
            if (!(((_result4 = result) === null || _result4 === void 0 ? void 0 : _result4.status) === 'chose_to_cancel')) {
              _context16.next = 18;
              break;
            }
            dispatch({
              type: c.CANCEL_RUBRIQ_PLAN
            });
            dispatch(notifyAboutPlanUpdate('curie.plan-update-cancel-success'));
            return _context16.abrupt("return", {
              success: true,
              status: result.status
            });
          case 18:
            _context16.next = 20;
            return dispatch(application.post('/api/curie/plan-cancel-immediately', {
              subscriptionId: subscriptionId
            }));
          case 20:
            response = _context16.sent;
            if (response !== null && response !== void 0 && response.success) {
              dispatch({
                type: c.CANCEL_RUBRIQ_PLAN
              });
              dispatch(notifyAboutPlanUpdate('curie.plan-update-cancel-success'));
            } else {
              dispatch(application.addMessage({
                type: 'error',
                message: 'rubriq.subscription-cancel-failed'
              }));
            }
            return _context16.abrupt("return", response);
          case 23:
          case "end":
            return _context16.stop();
        }
      }, _callee16, null, [[3, 9]]);
    }));
    return function (_x42, _x43, _x44) {
      return _ref41.apply(this, arguments);
    };
  }();
};
export var notifyAboutPlanUpdate = function notifyAboutPlanUpdate(successMessage) {
  return function (dispatch, getState, _ref42) {
    var application = _ref42.application;
    dispatch(application.addMessage({
      type: 'success',
      message: successMessage
    }));
  };
};
export var notifyAboutDoccumentIthenticateStatusUpdate = function notifyAboutDoccumentIthenticateStatusUpdate(successMessage, success) {
  return function (dispatch, getState, _ref43) {
    var application = _ref43.application;
    if (success) {
      dispatch(application.addMessage({
        type: 'success',
        message: successMessage
      }));
    } else {
      dispatch(application.addMessage({
        type: 'error',
        message: successMessage
      }));
    }
  };
};
export var clearTransitionModal = function clearTransitionModal() {
  return function (dispatch, getState, _ref44) {
    var application = _ref44.application;
    dispatch({
      type: c.TRANSITION_MODAL_CLEARED
    });
    return dispatch(application.post("/api/curie/notify/launch"));
  };
};
export var cancelCuriePlan = function cancelCuriePlan() {
  return function (dispatch) {
    dispatch({
      type: c.CANCEL_RUBRIQ_PLAN
    });
    dispatch(notifyAboutPlanUpdate('curie.plan-update-cancel-success'));
  };
};
export var linkPreprintsAccount = function linkPreprintsAccount(rsuid) {
  return function (dispatch, getState, _ref45) {
    var application = _ref45.application;
    return dispatch(application.post("/api/curie/account/link", {
      preprintsUserIdentity: rsuid
    })).then(function (json) {
      var error = json.error;
      if (error) {
        dispatch(setError({
          title: 'connection failed',
          content: 'curie.preprints-connection-failure',
          primaryBtnText: 'got-it'
        }));
      }
      return !error;
    });
  };
};
export var startCriteriaWizardSession = function startCriteriaWizardSession() {
  return function (dispatch, getState, _ref46) {
    var application = _ref46.application;
    return dispatch(application.post("/api/writer/start")).then(function (json) {
      var session = json.session;
      dispatch(_objectSpread({
        type: c.CRITERIA_WIZARD_SESSION_STARTED
      }, json));
      return session;
    });
  };
};
export var loadCriteriaWizardSession = function loadCriteriaWizardSession(sessionIdentity) {
  return function (dispatch, getState, _ref47) {
    var application = _ref47.application;
    return dispatch(application.get("/api/writer/steps")).then(function (json) {
      var steps = json;
      return dispatch(application.post("/api/writer/load/".concat(sessionIdentity))).then(function (json) {
        var session = json.session,
          currentStep = json.currentStep,
          criteriaResponses = json.criteriaResponses,
          templateResponses = json.templateResponses,
          title = json.title;
        var result = _objectSpread(_objectSpread({}, steps), {}, {
          session: session,
          currentStep: currentStep,
          criteriaResponses: criteriaResponses,
          templateResponses: templateResponses,
          title: title
        });
        dispatch(_objectSpread({
          type: c.CRITERIA_WIZARD_SESSION_LOADED
        }, result));
        return result;

        // TODO: handle invalid session identity error
      });

      // TODO: have the steps returned in the payload of "/api/writer/load" to avoid the extra API call
    });
  };
};
export var saveCriteriaWizardSession = function saveCriteriaWizardSession(step, responseData) {
  return function (dispatch, getState, _ref48) {
    var application = _ref48.application;
    var _getState = getState(),
      curie = _getState.curie;
    var _curie$abstractWriter = curie.abstractWriter,
      session = _curie$abstractWriter.session,
      criteriaResponses = _curie$abstractWriter.criteriaResponses;
    var payload = {
      session: session
    };
    if (responseData) {
      // set up next step and updated responses based on the provided response
      var nextStep = getNextStep({
        curie: curie
      }, step, responseData);
      var updatedResponses = getUpdatedResponses({
        curie: curie
      }, step, responseData);
      payload.currentStep = nextStep;
      payload.criteriaResponses = updatedResponses;
      if (responseData.title) payload.title = responseData.title;
    } else {
      // just save the current step after the user navigated to it
      payload.currentStep = step;
      payload.criteriaResponses = _objectSpread({}, criteriaResponses);
    }
    return dispatch(application.post("/api/writer/save", payload)).then(function (json) {
      var session = json.session,
        title = json.title;

      // TODO: this is just temporary until all session data is returned from the API (instead of just the session identity)
      var result = {
        session: session,
        title: title,
        currentStep: payload.currentStep,
        criteriaResponses: payload.criteriaResponses
      };
      dispatch(_objectSpread({
        type: c.CRITERIA_WIZARD_SESSION_SAVED
      }, result));
      return result;
    });
  };
};
export var saveTemplateSession = function saveTemplateSession(_ref49) {
  var sessionIdentity = _ref49.sessionIdentity,
    templateResponses = _ref49.templateResponses;
  return function (dispatch, getState, _ref50) {
    var application = _ref50.application;
    var payload = {
      session: sessionIdentity,
      templateResponses: templateResponses
    };
    dispatch(_objectSpread({
      type: c.TEMPLATE_RESPONSE_SAVED
    }, templateResponses));
    return dispatch(application.post("/api/writer/save", payload));
  };
};
export var updateSessionStage = function updateSessionStage(sessionIdentity, stage) {
  return function (dispatch, getState, _ref51) {
    var application = _ref51.application;
    return dispatch(application.post("/api/writer/update-stage", {
      session: sessionIdentity,
      stage: stage
    })).then(function (json) {
      dispatch(_objectSpread({
        type: c.SESSION_SAVED
      }, json));
      return json;
    });
  };
};

// TODO: Finish implementation once endpoints are ready
export var searchAbstracts = function searchAbstracts() {
  return function (dispatch, getState, _ref52) {
    var application = _ref52.application;
    dispatch({
      type: c.ABSTRACT_SEARCH_REQUESTED
    });
    return dispatch(application.get("/api/writing-workspace/search")).then(function (response) {
      // TODO:  Temporary stub to populate the abstract list, remove once abstract fetching is fully implemented

      var abstracts = response.map(function (abstract) {
        return {
          steps: {},
          session: abstract.session,
          currentStep: '',
          currentStage: 'Setup',
          responses: {},
          abstracts: [],
          title: 'My First Abstract Session',
          createdAt: moment(abstract.createdAt)
        };
      });
      dispatch({
        type: c.ABSTRACT_SEARCH_COMPLETED,
        abstracts: abstracts
      });
      return abstracts;
    });
  };
};
export var createPaddleFapiao = function createPaddleFapiao(fapiaoCreationRequest) {
  return function (dispatch, getState, _ref53) {
    var application = _ref53.application;
    return dispatch(application.post("/api/fapiao", fapiaoCreationRequest)).then(function (json) {
      var error = json.error;
      if (error) {
        dispatch(application.addMessage({
          type: 'error',
          message: error.error
        }));
      } else {
        dispatch(application.addMessage({
          type: 'success',
          message: "fapiao-creation-success-type-general"
        }));
      }
      return json;
    });
  };
};
export var loadEligiblePayments = function loadEligiblePayments() {
  return function (dispatch, getState, _ref54) {
    var application = _ref54.application;
    if (!getState().user.loggedIn) {
      return null;
    }
    return new Promise(function (resolve) {
      setTimeout(function () {
        dispatch(application.get('/api/paddle-fapiao/eligible-payments')).then(function (response) {
          dispatch({
            type: c.PADDLE_INVOICES_LOADED,
            payments: response.payments
          });
          resolve(response.payments);
        });
      }, 2000);
    });
  };
};
export var downloadPaddleReceipt = function downloadPaddleReceipt(paymentId) {
  return function (dispatch, getState, _ref55) {
    var application = _ref55.application;
    if (!getState().user.loggedIn) {
      return null;
    }
    return new Promise(function (resolve) {
      dispatch(application.get("/api/paddle-fapiao/download-paddle-invoice/".concat(paymentId))).then(function (response) {
        if (response && response.paddle_invoice_url) {
          window.open(response.paddle_invoice_url);
        }
        resolve(response);
      }).catch(function (error) {
        dispatch(application.addMessage({
          type: 'error',
          message: error.error || 'Failed to download Invoice'
        }));
      });
    });
  };
};
export var onFapiaoCancelled = function onFapiaoCancelled(fapiao) {
  return {
    type: c.PADDLE_FAPIAO_CANCELLED,
    retainerInvoiceNumber: fapiao.receiptCode,
    fapiao: fapiao
  };
};
// TODO: Implement once delete backend work is complete
export var deleteAbstract = function deleteAbstract() {};
export var fetchPaddlePrices = function fetchPaddlePrices() {
  return /*#__PURE__*/function () {
    var _ref56 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(dispatch, getState) {
      var enablePaddleCountryPrice, PADDLE_ZERO_DECIMAL_CURRENCIES, getDivisor, _state$application, _state$curie2, _result$data, state, _ref57, clientToken, environment, scriptUrlv2, customerPaddleId, availablePlans, priceIds, initializePaddle, result, prices, currency, currencyCode, divisor;
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            enablePaddleCountryPrice = true;
            PADDLE_ZERO_DECIMAL_CURRENCIES = ['JPY', 'KRW', 'VND'];
            getDivisor = function getDivisor(currencyCode) {
              return PADDLE_ZERO_DECIMAL_CURRENCIES.includes(currencyCode) ? 1 : 100;
            };
            if (enablePaddleCountryPrice) {
              _context17.next = 5;
              break;
            }
            return _context17.abrupt("return");
          case 5:
            dispatch({
              type: 'FETCH_PADDLE_PRICES_REQUEST'
            });
            _context17.prev = 6;
            state = getState();
            _ref57 = ((_state$application = state.application) === null || _state$application === void 0 ? void 0 : _state$application.paddle) || {}, clientToken = _ref57.clientToken, environment = _ref57.environment, scriptUrlv2 = _ref57.scriptUrlv2, customerPaddleId = _ref57.customerPaddleId;
            if (!(!clientToken || !scriptUrlv2)) {
              _context17.next = 12;
              break;
            }
            dispatch({
              type: 'FETCH_PADDLE_PRICES_FAILURE'
            });
            return _context17.abrupt("return");
          case 12:
            availablePlans = (_state$curie2 = state.curie) === null || _state$curie2 === void 0 || (_state$curie2 = _state$curie2.plan) === null || _state$curie2 === void 0 ? void 0 : _state$curie2.availablePlans;
            if (availablePlans) {
              _context17.next = 16;
              break;
            }
            dispatch({
              type: 'FETCH_PADDLE_PRICES_FAILURE'
            });
            return _context17.abrupt("return");
          case 16:
            priceIds = [];
            Object.keys(availablePlans).forEach(function (planType) {
              var planArray = availablePlans[planType];
              if (Array.isArray(planArray)) {
                planArray.forEach(function (plan) {
                  if (plan && plan.paddlePlanId) {
                    priceIds.push(plan.paddlePlanId);
                  }
                });
              }
            });
            if (!(priceIds.length === 0)) {
              _context17.next = 21;
              break;
            }
            dispatch({
              type: 'FETCH_PADDLE_PRICES_FAILURE'
            });
            return _context17.abrupt("return");
          case 21:
            initializePaddle = function initializePaddle() {
              return new Promise(function (resolve, reject) {
                var _window$Paddle2;
                if ((_window$Paddle2 = window.Paddle) !== null && _window$Paddle2 !== void 0 && _window$Paddle2.Initialized) {
                  resolve();
                  return;
                }
                var existingScript = document.getElementById('paddleBillingScript');
                if (existingScript) {
                  var checkInit = setInterval(function () {
                    var _window$Paddle3;
                    if ((_window$Paddle3 = window.Paddle) !== null && _window$Paddle3 !== void 0 && _window$Paddle3.Initialized) {
                      clearInterval(checkInit);
                      resolve();
                    }
                  }, 100);
                  setTimeout(function () {
                    var _window$Paddle4;
                    clearInterval(checkInit);
                    if ((_window$Paddle4 = window.Paddle) !== null && _window$Paddle4 !== void 0 && _window$Paddle4.Initialized) {
                      resolve();
                    } else {
                      reject(new Error('Paddle initialization timeout'));
                    }
                  }, 15000);
                  return;
                }
                var scriptTag = document.createElement('script');
                scriptTag.id = 'paddleBillingScript';
                scriptTag.async = true;
                scriptTag.src = scriptUrlv2;
                scriptTag.onload = function () {
                  if (window.Paddle) {
                    if (environment === 'sandbox') {
                      window.Paddle.Environment.set('sandbox');
                    }
                    window.Paddle.Initialize({
                      token: clientToken,
                      eventCallback: paddleEventCallback,
                      pwCustomer: {
                        id: customerPaddleId
                      }
                    });
                    var _checkInit = setInterval(function () {
                      if (window.Paddle.Initialized) {
                        clearInterval(_checkInit);
                        resolve();
                      }
                    }, 100);
                    setTimeout(function () {
                      var _window$Paddle5;
                      clearInterval(_checkInit);
                      if ((_window$Paddle5 = window.Paddle) !== null && _window$Paddle5 !== void 0 && _window$Paddle5.Initialized) {
                        resolve();
                      } else {
                        reject(new Error('Paddle initialization timeout after load'));
                      }
                    }, 10000);
                  } else {
                    reject(new Error('Paddle object not found after script load'));
                  }
                };
                scriptTag.onerror = function () {
                  reject(new Error('Failed to load Paddle script'));
                };
                document.body.appendChild(scriptTag);
              });
            };
            _context17.next = 24;
            return initializePaddle();
          case 24:
            if (!(!window.Paddle || !window.Paddle.Initialized)) {
              _context17.next = 26;
              break;
            }
            throw new Error('Paddle not properly initialized');
          case 26:
            _context17.next = 28;
            return window.Paddle.PricePreview({
              items: priceIds.map(function (priceId) {
                return {
                  priceId: priceId,
                  quantity: 1
                };
              })
            });
          case 28:
            result = _context17.sent;
            prices = {};
            currency = null;
            if ((_result$data = result.data) !== null && _result$data !== void 0 && (_result$data = _result$data.details) !== null && _result$data !== void 0 && _result$data.lineItems) {
              currencyCode = result.data.currencyCode;
              divisor = getDivisor(currencyCode);
              result.data.details.lineItems.forEach(function (item) {
                var formatted = item.formattedTotals.total;
                var currencySymbol = formatted.replace(/[\d,.\s]/g, '').trim();
                prices[item.price.id] = {
                  amount: parseInt(item.totals.total, 10) / divisor,
                  formatted: formatted,
                  currency: currencyCode,
                  currencySymbol: currencySymbol || currencyCode
                };
              });
              currency = currencyCode;
            }
            dispatch({
              type: 'FETCH_PADDLE_PRICES_SUCCESS',
              payload: {
                prices: prices,
                currency: currency
              }
            });
            _context17.next = 38;
            break;
          case 35:
            _context17.prev = 35;
            _context17.t0 = _context17["catch"](6);
            dispatch({
              type: 'FETCH_PADDLE_PRICES_FAILURE'
            });
          case 38:
          case "end":
            return _context17.stop();
        }
      }, _callee17, null, [[6, 35]]);
    }));
    return function (_x45, _x46) {
      return _ref56.apply(this, arguments);
    };
  }();
};
export var fetchTransactionPreview = function fetchTransactionPreview() {
  return /*#__PURE__*/function () {
    var _ref58 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(dispatch, getState) {
      var _state$curie3, _window$Paddle6, _window$Paddle8, _result$data2, _result$data3, _result$data4, state, paddlePlanId, result, totals, currencyCode, ZERO_DECIMAL_CURRENCIES, divisor, formattedTotal;
      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            state = getState();
            paddlePlanId = (_state$curie3 = state.curie) === null || _state$curie3 === void 0 || (_state$curie3 = _state$curie3.plan) === null || _state$curie3 === void 0 ? void 0 : _state$curie3.paddlePlanId;
            if (paddlePlanId) {
              _context18.next = 5;
              break;
            }
            throw new Error('Missing paddlePlanId');
          case 5:
            if ((_window$Paddle6 = window.Paddle) !== null && _window$Paddle6 !== void 0 && _window$Paddle6.Initialized) {
              _context18.next = 8;
              break;
            }
            _context18.next = 8;
            return new Promise(function (resolve) {
              var interval = setInterval(function () {
                var _window$Paddle7;
                if ((_window$Paddle7 = window.Paddle) !== null && _window$Paddle7 !== void 0 && _window$Paddle7.Initialized) {
                  clearInterval(interval);
                  resolve();
                }
              }, 100);
              setTimeout(function () {
                clearInterval(interval);
                resolve();
              }, 10000);
            });
          case 8:
            if ((_window$Paddle8 = window.Paddle) !== null && _window$Paddle8 !== void 0 && _window$Paddle8.TransactionPreview) {
              _context18.next = 10;
              break;
            }
            throw new Error('Paddle TransactionPreview unavailable');
          case 10:
            _context18.next = 12;
            return window.Paddle.TransactionPreview({
              items: [{
                priceId: paddlePlanId,
                quantity: 1
              }],
              ignoreTrials: true
            });
          case 12:
            result = _context18.sent;
            totals = result === null || result === void 0 || (_result$data2 = result.data) === null || _result$data2 === void 0 || (_result$data2 = _result$data2.details) === null || _result$data2 === void 0 ? void 0 : _result$data2.totals;
            currencyCode = (result === null || result === void 0 || (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.currency_code) || (result === null || result === void 0 || (_result$data4 = result.data) === null || _result$data4 === void 0 ? void 0 : _result$data4.currencyCode);
            ZERO_DECIMAL_CURRENCIES = ['JPY', 'KRW'];
            divisor = ZERO_DECIMAL_CURRENCIES.includes(currencyCode) ? 1 : 100;
            formattedTotal = new Intl.NumberFormat('en', {
              style: 'currency',
              currency: currencyCode
            }).format(Number((totals === null || totals === void 0 ? void 0 : totals.total) || 0) / divisor);
            return _context18.abrupt("return", {
              subtotal: totals === null || totals === void 0 ? void 0 : totals.subtotal,
              tax: totals === null || totals === void 0 ? void 0 : totals.tax,
              total: totals === null || totals === void 0 ? void 0 : totals.total,
              currencyCode: currencyCode,
              formattedTotal: formattedTotal,
              fullResponse: result
            });
          case 21:
            _context18.prev = 21;
            _context18.t0 = _context18["catch"](0);
            return _context18.abrupt("return", null);
          case 24:
          case "end":
            return _context18.stop();
        }
      }, _callee18, null, [[0, 21]]);
    }));
    return function (_x47, _x48) {
      return _ref58.apply(this, arguments);
    };
  }();
};